export default __webpack_public_path__ + "static/media/android_dev.3f900eff.png";